import { OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { MainSideBarService } from '../shared/main-side-bar/main-side-bar.service';
import { HomeUrlHelper } from '@sc/pas-common';
import { ListSetService } from 'app/core/services/list-set.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RejectionSearchService } from 'app/modules/policy-lists/services/rejection-search.service';
var LegacyComponent = /** @class */ (function () {
    function LegacyComponent(router, route, mainSideBarService, urlHelper, listSetService, rejectionSearchService, ref) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.mainSideBarService = mainSideBarService;
        this.urlHelper = urlHelper;
        this.listSetService = listSetService;
        this.rejectionSearchService = rejectionSearchService;
        this.ref = ref;
        this.iframeBodySRC = '';
        this.jwtHelperService = new JwtHelperService();
        this.urlLoaded = false;
        this.stateObserver = new Subject();
        this.onMessage()
            .subscribe(function (message) {
        });
        route.queryParams
            .subscribe(function (params) {
            var sbIndex = params['sb'];
            _this.sbIndexValue = sbIndex;
            var branchIndex = params['branchIndex'];
            if (sbIndex) {
                _this.mainSideBarService.getData()
                    .subscribe(function (JSONData) {
                    _this.sbData = JSONData;
                    var urlItem = _this.urlHelper.getFromJSON(JSONData, sbIndex);
                    var url = _this.urlHelper.urlByOrigin(urlItem.link, urlItem.origin);
                    _this.urlHelper.addTokenUrlItem(url, urlItem.tokenType)
                        .subscribe(function (urlParsed) {
                        _this.urlLoaded = false;
                        _this.iframeBodySRC = urlParsed;
                        _this.ref.detectChanges();
                    });
                    _this.profileItems = JSONData && JSONData['profile'];
                });
            }
            else if (branchIndex) {
                _this.listSetService.branchSelectorData()
                    .subscribe(function (branchData) {
                    var urlItem = branchData[branchIndex];
                    var url = _this.urlHelper.urlByOrigin(urlItem.link, urlItem.origin);
                    _this.urlHelper.addTokenUrlItem(url, urlItem.tokenType, null, urlItem.redirectTo)
                        .subscribe(function (urlParsed) {
                        _this.urlLoaded = false;
                        _this.iframeBodySRC = urlParsed;
                        _this.ref.detectChanges();
                    });
                });
            }
        });
    }
    LegacyComponent.prototype.ngOnInit = function () {
        this.token = localStorage.getItem('tk');
        this.user = this.token && this.jwtHelperService.decodeToken(this.token);
        if (this.route.queryParams && this.route.queryParams['value'] && this.route.queryParams['value'].url) {
            this.iframeBodySRC = this.route.queryParams['value'].url;
        }
    };
    LegacyComponent.prototype.onMessage = function () {
        return new Observable(function (observer) {
            window.addEventListener('message', function (event) {
                if (typeof (event.data) !== 'undefined') {
                    observer.next(event.data);
                }
            });
        });
    };
    LegacyComponent.prototype.onLoaded = function (e) {
        this.urlLoaded = true;
        this.ref.detectChanges();
    };
    return LegacyComponent;
}());
export { LegacyComponent };
